import IconPromise from 'components/widgets/IconPromise/IconPromise';
import SvgIcon from 'components/commons/icons/SvgIcon';
import { ReactComponent as Ic_Warning_Circle } from 'resources/icons/Ic_Warning_Circle.svg';
import { useTheme } from 'context/themeContext';
import { useSelector } from 'react-redux';
import { transportModeState } from 'redux/slices/transportmodeSlice';

import './codeStop.scss';

interface ICodeStop {
  transportMode:string
  text:string
  routeColor?:string
  routeTextColor?:string
  light?:boolean
  styles?:React.CSSProperties;
  warning?:boolean;
  onClick?:(e) => void
}
export default function CodeStop(props:ICodeStop) {

  const { text, routeColor, routeTextColor, styles, onClick, transportMode } = props;
  const theme = useTheme();
  const selectorTransportModes = useSelector(transportModeState);
  const getTransportModeIcon = () => {
    const iconId = selectorTransportModes?.find((transporte) => Number(transporte.id) === Number(transportMode))?.iconId;
    return iconId;
  };

  return (
    <div className='codeStop' style={{background: routeColor ? routeColor : theme.colors.primary_300, ...styles}} onClick={(e)=> onClick && onClick(e)}>
        <IconPromise idIcon={getTransportModeIcon()}/>
        <span style={{color: routeTextColor ? routeTextColor : theme.colors.white}}>{text}</span>
        {
                props.warning && <SvgIcon
                  Icon={Ic_Warning_Circle}
                  className='warning-icon'
                  ariaLabel='warning'
                  />
          }
    </div>
  );
}
